export default "__VITE_ASSET__DKIB$L8Q__";